import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { Conditionnement } from './conditionnement.model';
import { NatureClientService } from '../../../../core/services/nature-client.service';
import { ConditionnementsClientService } from '../../../../core/services/conditionnements-client.service';
import { IConditionnement } from '../../../../core/models/conditionnements.model';
import { InlineResponse } from '../../../../core/models/inline-response.model';

@Injectable({
  providedIn: 'root',
})
export class ReferentialsConditionnementsService {
  constructor(private conditionnementsClientService: ConditionnementsClientService) {}

  getConditionnementData(): Observable<Conditionnement[]> {
    return this.conditionnementsClientService.getConditionnementData().pipe(
      map((conditionnement) => conditionnement.rows),
      map((rows) => rows.map((row) => new Conditionnement(row.codeHecate, row.designation, row.id))),
    );
  }

  addConditionnementData(codeHecate: number, designation: string): Observable<InlineResponse> {
    return this.conditionnementsClientService.addConditionnementData(codeHecate, designation);
  }

  updateConditionnementData(conditionnement: Conditionnement): Observable<InlineResponse> {
    return this.conditionnementsClientService.updateConditionnementData(conditionnement);
  }
}
